import L from 'leaflet';
import { env } from '../config/env';

const iconBase = env.leafletIconBase;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: `${iconBase}/marker-icon-2x.png`,
  iconUrl: `${iconBase}/marker-icon.png`,
  shadowUrl: `${iconBase}/marker-shadow.png`,
});

export const DEFAULT_MAP_CENTER = env.defaultMapCenter;
